const searchResults = document.querySelector('[data-search-results]');
const MIN_SEARCH_LENGTH = 3;
const DISALLOWED_SEARCH_CHARS = /[^a-zA-Z0-9çğıöşüÇĞİÖŞÜ\s]/g;

const sanitizeSearchValue = (value) => (value || '')
    .replace(DISALLOWED_SEARCH_CHARS, '')
    .replace(/\s+/g, ' ')
    .trim();

if (searchResults) {
    const form = searchResults.querySelector('.search-results__form');
    const input = searchResults.querySelector('.search-results__input');
    const queryText = searchResults.querySelector('[data-search-results-query]');
    const pagination = searchResults.querySelector('[data-search-pagination]');
    const list = searchResults.querySelector('[data-search-results-list]');
    const summary = searchResults.querySelector('[data-search-results-summary]');
    const popular = searchResults.querySelector('[data-search-popular]');
    const searchUrl = searchResults.dataset.searchUrl;
    const csrfToken = searchResults.querySelector('input[name="__RequestVerificationToken"]')?.value;

    const params = new URLSearchParams(window.location.search);
    const query = sanitizeSearchValue(params.get('q') || '');
    let currentQuery = query;
    let isLoading = false;
    let fetchResults = () => {};

    const createResultItem = (item) => {
        const article = document.createElement('article');
        const link = document.createElement('a');
        const text = document.createElement('div');

        article.className = 'search-results__item';
        link.className = 'search-results__title';
        link.href = item.url || '#';
        link.textContent = item.title || '';
        text.className = 'search-results__text';
        text.innerHTML = item.description || '';

        article.appendChild(link);
        article.appendChild(text);

        return article;
    };

    const setSummary = (keyword, totalRecords) => {
        const targetSummary = summary || searchResults.querySelector('.search-results__summary');

        if (!targetSummary) {
            return;
        }

        targetSummary.innerHTML = '';

        const strong = document.createElement('strong');
        strong.dataset.searchResultsQuery = '';
        strong.textContent = `"${keyword.toLocaleLowerCase('tr-TR')}"`;

        targetSummary.appendChild(strong);
        targetSummary.append(` için ${totalRecords} sonuç bulundu.`);
        targetSummary.hidden = false;
    };

    const setPopular = (isVisible) => {
        if (popular) {
            popular.hidden = !isVisible;
        }
    };

    const scrollToResultsTop = () => {
        searchResults.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    if (input) {
        input.value = query;
    }

    if (queryText) {
        queryText.textContent = `"${query.toLocaleLowerCase('tr-TR')}"`;
    }

    if (form && input) {
        const setWarning = (isWarning) => {
            form.classList.toggle('is-warning', isWarning);
        };

        if (query.length > 0 && query.trim().length < MIN_SEARCH_LENGTH) {
            setWarning(true);
        }

        input.addEventListener('input', () => {
            const cleaned = input.value.replace(DISALLOWED_SEARCH_CHARS, '');

            if (cleaned !== input.value) {
                const caret = input.selectionStart;
                const removed = input.value.length - cleaned.length;
                input.value = cleaned;
                const position = Math.max(0, caret - removed);
                input.setSelectionRange(position, position);
            }

            if (sanitizeSearchValue(input.value).length >= MIN_SEARCH_LENGTH) {
                setWarning(false);
            }
        });

        form.addEventListener('submit', (event) => {
            const value = sanitizeSearchValue(input.value);

            if (searchUrl) {
                event.preventDefault();
            }

            if (value.length < MIN_SEARCH_LENGTH) {
                event.preventDefault();
                setWarning(true);
                return;
            }

            setWarning(false);
            input.value = value;

            if (searchUrl) {
                currentQuery = value;
                window.history.pushState({}, '', `${window.location.pathname}?q=${encodeURIComponent(currentQuery)}`);
                fetchResults(currentQuery, 1);
            }
        });
    }

    if (pagination) {
        let totalPages = parseInt(pagination.dataset.totalPages, 10) || 1;
        let currentPage = parseInt(pagination.dataset.currentPage, 10) || 1;

        const getPageItems = () => {
            if (totalPages <= 7) {
                return Array.from({ length: totalPages }, (_, index) => index + 1);
            }

            if (currentPage <= 3) {
                return [1, 2, 3, 4, 'ellipsis', totalPages];
            }

            if (currentPage >= totalPages - 2) {
                return [1, 'ellipsis', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
            }

            return [1, 'ellipsis-start', currentPage - 1, currentPage, currentPage + 1, 'ellipsis-end', totalPages];
        };

        const createControl = (direction) => {
            const button = document.createElement('button');
            const isPrev = direction === 'prev';

            button.className = 'search-results__page search-results__page--control';
            button.type = 'button';
            button.setAttribute('aria-label', isPrev ? 'Önceki sayfa' : 'Sonraki sayfa');
            button.dataset.searchPaginationControl = direction;
            button.disabled = isPrev ? currentPage === 1 : currentPage === totalPages;
            button.innerHTML = `
                <svg class="search-results__page-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                    <path d="${isPrev ? 'M10 3.33 5.33 8 10 12.67' : 'm6 3.33 4.67 4.67L6 12.67'}" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `;

            return button;
        };

        const createPage = (page) => {
            const button = document.createElement('button');

            button.className = 'search-results__page';
            button.type = 'button';
            button.textContent = page;
            button.dataset.searchPage = page;

            if (page === currentPage) {
                button.classList.add('is-active');
                button.setAttribute('aria-current', 'page');
            }

            return button;
        };

        const createEllipsis = () => {
            const span = document.createElement('span');

            span.className = 'search-results__page search-results__page--ellipsis';
            span.setAttribute('aria-hidden', 'true');
            span.textContent = '...';

            return span;
        };

        const renderPagination = () => {
            pagination.hidden = totalPages <= 1;
            pagination.innerHTML = '';

            if (totalPages <= 1) {
                return;
            }

            pagination.appendChild(createControl('prev'));

            getPageItems().forEach((item) => {
                pagination.appendChild(typeof item === 'number' ? createPage(item) : createEllipsis());
            });

            pagination.appendChild(createControl('next'));
            pagination.dataset.currentPage = currentPage;
            pagination.dataset.totalPages = totalPages;
        };

        const setPagination = (page, pageCount) => {
            currentPage = Math.min(Math.max(page, 1), pageCount || 1);
            totalPages = pageCount || 1;
            renderPagination();
        };

        fetchResults = async (keyword, page) => {
            if (!searchUrl || !list || isLoading) {
                return;
            }

            isLoading = true;
            searchResults.classList.add('is-loading');
            setPopular(false);

            try {
                const formData = new FormData();
                formData.append('q', keyword);
                formData.append('page', page);

                if (csrfToken) {
                    formData.append('__RequestVerificationToken', csrfToken);
                }

                const response = await fetch(searchUrl, {
                    method: 'POST',
                    body: formData
                });

                if (!response.ok) {
                    throw new Error('Search request failed');
                }

                const data = await response.json();
                const results = Array.isArray(data.results) ? data.results : [];

                list.innerHTML = '';
                setPopular(results.length === 0);

                if (results.length > 0) {
                    results.forEach((item) => {
                        list.appendChild(createResultItem(item));
                    });
                }

                setSummary(keyword, data.totalRecords || 0);
                setPagination(data.page || page, data.totalPages || 1);
            } catch (error) {
                console.error('Search error:', error);
            } finally {
                isLoading = false;
                searchResults.classList.remove('is-loading');
            }
        };

        pagination.addEventListener('click', (event) => {
            const control = event.target.closest('[data-search-pagination-control]');
            const pageButton = event.target.closest('[data-search-page]');
            const previousPage = currentPage;

            if (control) {
                currentPage += control.dataset.searchPaginationControl === 'next' ? 1 : -1;
            } else if (pageButton) {
                currentPage = parseInt(pageButton.dataset.searchPage, 10);
            } else {
                return;
            }

            currentPage = Math.min(Math.max(currentPage, 1), totalPages);

            if (currentPage === previousPage) {
                return;
            }

            if (searchUrl && currentQuery.length >= MIN_SEARCH_LENGTH) {
                fetchResults(currentQuery, currentPage);
                scrollToResultsTop();
                return;
            }

            renderPagination();
            scrollToResultsTop();
        });

        renderPagination();

        if (searchUrl && currentQuery.length >= MIN_SEARCH_LENGTH) {
            fetchResults(currentQuery, currentPage);
        } else if (currentQuery.length === 0) {
            setPopular(true);
        }
    }
}
